import React from 'react';
import { useTranslation } from 'react-i18next';

import SeoHero from '../components/SeoHero/SeoHero';
import SeoFeatures from '../components/SeoFeatures/SeoFeatures';
import SeoProcess from '../components/SeoProcess/SeoProcess';
import SeoPortfolio from '../components/SeoPortfolio/SeoPortfolio';
import ModernWhyChooseUs from '../components/ModernWhyChooseUs/ModernWhyChooseUs';
import SeoCta from '../components/SeoCta/SeoCta';

const SeoPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <SeoHero />
      <SeoFeatures />
      <SeoProcess />
      <SeoPortfolio />
      <ModernWhyChooseUs />
      <SeoCta />
    </>
  );
};

export default SeoPage;
